import React from 'react'
import VolvoLogo from "../../../../styles/img/volvo-logo.png"
import Inner from "../../../../styles/img/inner-featured-top-img.png"
import { UiButtonPrimary } from '../form/UiButton'

export default function UiInnerTopSliderCard(props) {


    return (
        <>
            <div className='sb-top-slider-card-wr'>
                <div className='sb-top-slider-card-border'>
                    <div className='sb-top-slider-card'>
                        <div className='sb-top-slider-card__left-col'>
                            <div className='sb-top-slider-card__featured-logo'>
                                <img src={VolvoLogo} />
                            </div>
                            <div className='sb-top-slider-card__heading'>
                                <span>Featured Campaign</span>
                            </div>
                            <div className='sb-top-slider-card__featured-title'>
                                <h3>EX90 Campaign</h3>
                            </div>
                            <div className='sb-top-slider-card__body'> 
                                <p>Tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum.</p>
                            </div>
                            <UiButtonPrimary btnName="Learn more" size="30"/> 
                        </div>
                        <div className='sb-top-slider-card__right-col'>
                            <img src={Inner} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
